"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupLevelSidebarApp = void 0;
const vue_1 = require("vue");
const provider_1 = require("../provider/provider");
const groupLevelSidebarImpl_1 = require("../presenter/groupLevelSidebarImpl");
class GroupLevelSidebarApp {
    constructor(app, branchId, userId, props, isBranchOrGroupOwner) {
        const viewModel = (0, vue_1.ref)({
            branchId: branchId,
            userId: userId,
            currentPage: props.currentPage,
            isSidebarOpen: true,
            groupDashPermissions: props.groupDashPermissions,
            enableKOT: Boolean(props.enableKOT),
            isGroupOwner: props.isGroupOwner || false,
            hasUnpaid: props.hasUnpaid,
            isBranchOrGroupOwner
        });
        app.provide(provider_1.groupLevelSidebarViewModelInjectKey, (0, vue_1.readonly)(viewModel));
        const groupLevelSidebarPresenter = new groupLevelSidebarImpl_1.GroupLevelSidebarPresenterImpl(viewModel.value);
        app.provide(provider_1.groupLevelSidebarPresenterInjectKey, groupLevelSidebarPresenter);
    }
}
exports.GroupLevelSidebarApp = GroupLevelSidebarApp;
